(function () {
  document.addEventListener('click', function (e) {
    if (e.target.closest('#CartDiscountApply')) applyDiscount();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && document.getElementById('CartDiscountInput') === document.activeElement) {
      applyDiscount();
    }
  });

  async function applyDiscount() {
    var input = document.getElementById('CartDiscountInput');
    var btn = document.getElementById('CartDiscountApply');
    if (!input || !btn) return;
    var code = input.value.trim();
    if (!code) return;

    btn.disabled = true;
    btn.querySelector('span').textContent = 'Applying...';
    setMessage('', '');

    try {
      var cartBefore = await fetch('/cart.js').then(function (r) { return r.json(); });
      var totalBefore = cartBefore.total_price;

      await fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' });

      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });

      var cartLevelApplied = Array.isArray(cart.cart_level_discount_applications) &&
        cart.cart_level_discount_applications.some(function (d) {
          return d.code && d.code.toUpperCase() === code.toUpperCase();
        });
      var priceReduced = cart.total_price < totalBefore;
      var applied = cartLevelApplied || priceReduced;

      if (applied) {
        await refreshDrawer();
        setMessage('Code ' + code.toUpperCase() + ' applied', 'success');
      } else {
        setMessage('Code is invalid', 'error');
        btn.disabled = false;
        btn.querySelector('span').textContent = 'Apply';
      }
    } catch (_) {
      setMessage('Code is invalid', 'error');
      btn.disabled = false;
      btn.querySelector('span').textContent = 'Apply';
    }
  }

  async function refreshDrawer() {
    var res = await fetch(window.location.href);
    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.getElementById('Cart-Drawer');
    var curr = document.getElementById('Cart-Drawer');
    if (next && curr) curr.innerHTML = next.innerHTML;
  }

  function setMessage(text, type) {
    var el = document.getElementById('CartDiscountMessage');
    if (!el) return;
    el.textContent = text;
    el.className = 'cart-discount__message' + (type ? ' cart-discount__message--' + type : '');
  }
})();